import { createEnumMap, mapEnum } from 'Commons/helpers/utils/Formatter';
import enums from './Enums';

const MAINTENANCE_EVENT_STATUS = createEnumMap(enums.maintenanceEventStatus, status => status);
const MAINTENANCE_EVENT_ACTION_ITEM = mapEnum(enums.maintenanceEventActionItem);

export { MAINTENANCE_EVENT_STATUS, MAINTENANCE_EVENT_ACTION_ITEM };
